import { memo } from "react";
function TextInput(props) {
  return (
    <div className="input-group input-group-lg my-2">
      <span
        className="input-group-text bg-warning"
        id="inputGroup-sizing-lg"
      >
        <strong>{props.detail}</strong>
          
        
      </span>
      <input
        required
        type={props.type}
        name={props.name}
        onChange={(e) => props.Change(e.target.value)}
        value={props.value ? props.value : ""}
        className="form-control"
      />
    </div>
  );
}

export default memo(TextInput);
